export const BMO_TRANSACTION_TABLE_TITLE = 'Transactions';
export const BMO_TRANSACTION_TABLE_INFO_URL = '';
